export const ACTIVE_STEP_IS_COMPLETE = 'active_step_is_complete';
export const ACTIVE_STEP_NAME = 'active_step_name';
export const FIRST_STEP_IS_ACTIVE = 'first_step_is_active';
export const HIGHEST_UNLOCKED_STEP_INDEX = 'highest_unlocked_step_index';
export const LAST_STEP_IS_ACTIVE = 'last_step_is_active';
